var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIonCallOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.2813 35.7938C40.7925 34.2938 37.1869 32.1048 35.4375 31.2226C33.1594 30.0751 32.9719 29.9813 31.1813 31.3116C29.9869 32.1995 29.1929 32.9926 27.795 32.6945C26.3972 32.3963 23.3597 30.7154 20.7 28.0641C18.0404 25.4129 16.2619 22.2873 15.9629 20.8941C15.6638 19.501 16.47 18.7163 17.3494 17.5191C18.5888 15.8316 18.495 15.5504 17.4357 13.2723C16.6097 11.5004 14.3569 7.92851 12.8513 6.44726C11.2407 4.85633 11.2407 5.13758 10.2029 5.56883C9.35792 5.92424 8.54735 6.35636 7.7813 6.85976C6.2813 7.85633 5.4488 8.68414 4.86661 9.9282C4.28442 11.1723 4.02286 14.0888 7.02942 19.5507C10.036 25.0126 12.1454 27.8054 16.5113 32.1591C20.8772 36.5129 24.2344 38.8538 29.1422 41.6063C35.2135 45.0066 37.5422 44.3438 38.7901 43.7626C40.0379 43.1813 40.8694 42.3563 41.8679 40.8563C42.3725 40.0916 42.8056 39.2819 43.1616 38.4376C43.5938 37.4035 43.875 37.4035 42.2813 35.7938Z",
    stroke: "#04236B",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIonCallOutline);
export default __webpack_public_path__ + "static/media/ion_call-outline.56b169090fec088ceaeebe547488991a.svg";
export { ForwardRef as ReactComponent };